import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { DialogHost } from "./components/dialogs";
import { Toaster } from "./components/ui/toaster";
import { queryClient } from "./lib/api";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster />
      <DialogHost />
    </QueryClientProvider>
  </StrictMode>,
);
